export class SpecialSymbolGroup {
  collectCount: number | null;
  positions: number[] | null;
  positions2d: number[][] | null;
  positionsWin: number[] | null;
  previousPositions: number[] | null;
  previousSymbolId: number | null;
  subType: string | null;
  symbolId: number | null;
  totalWin: number | null;
  totalWinDouble: number | null;
  type: string | null;
  totalJackPotWin: number;
}
